<div content>
  <h3 *ngIf="risrAssessExam.title">{{ risrAssessExam.title }}</h3>
  <ul class="list-unstyled">
    <li *ngIf="risrAssessExam.sessionTitle"><strong>Session:</strong> {{ risrAssessExam.sessionTitle }}</li>
    <li *ngIf="risrAssessExam.startDate"><strong>Start
      Date:</strong> {{ risrAssessExam.startDate | date: 'd MMM y' }}
    </li>
    <li><strong>State:</strong> {{ RisrAssessExamStatesDisplayNames[risrAssessExam.state] }}</li>
  </ul>

  <rsr-alert variant="error" *ngIf="risrAssessExam.state === RisrAssessExamStates.ERROR">
    <p>{{risrAssessExam.errorMessage}}</p>
  </rsr-alert>

  <rsr-alert variant="error" *ngIf="risrAssessExam.state === RisrAssessExamStates.DELETED">
    <p i18n>Your exam has been deleted.</p>
  </rsr-alert>

  <div *ngIf="risrAssessExam.state === RisrAssessExamStates.WAITING_FOR_CREATION || risrAssessExam.state === RisrAssessExamStates.CREATED">
    <rsr-alert variant="accent" *ngIf="risrAssessExam.state === RisrAssessExamStates.WAITING_FOR_CREATION || risrAssessExam.state === RisrAssessExamStates.CREATED">
      <p i18n *ngIf="risrAssessExamType === ExamTypeEnum.COHORT">Thank you for your booking. Details of your exam will be communicated separately.</p>
      <p i18n *ngIf="risrAssessExamType !== ExamTypeEnum.COHORT">Your exam is being prepared... Please wait...</p>
    </rsr-alert>
  </div>

  <div *ngIf="(risrAssessExam.state === RisrAssessExamStates.PUSHED || risrAssessExam.state === RisrAssessExamStates.STARTED) && isOwner">
    <div *ngIf="risrAssessExamType === ExamTypeEnum.COHORT">
      <rsr-alert variant="primary" hideIcon="true">
        <p i18n>Thank you for your booking. Details of your exam will be communicated separately.</p>
      </rsr-alert>
    </div>
    <div *ngIf="risrAssessExamType !== ExamTypeEnum.COHORT">
      <rsr-alert variant="primary" hideIcon="true" *ngIf="risrAssessExam.state === RisrAssessExamStates.PUSHED">
        <p i18n>Your exam is ready. Please log in using the username and password below. You’ll be redirected to risr/assess to take your exam.</p>
      </rsr-alert>
      <rsr-alert variant="accent" *ngIf="risrAssessExam.state === RisrAssessExamStates.STARTED">
        <p i18n>You already started the exam. Please login using the username and password below. You will be redirected to risr/assess to take your exam.</p>
      </rsr-alert>

      <div class="box box-primary">
        <ul class="list-unstyled">
          <li>
            <strong>Username: </strong>{{risrAssessExam.username}}
            <rsr-button-copy-to-clipboard [text]="risrAssessExam.username" i18n-title title="Copy username" hideTitle="true" />
          </li>
          <li>
            <strong>Password: </strong>{{risrAssessExam.password}}
            <rsr-button-copy-to-clipboard [text]="risrAssessExam.password" i18n-title title="Copy password" hideTitle="true" />
          </li>
        </ul>
      </div>
      <button mat-flat-button color="primary" (click)="startExam()">
        <span *ngIf="risrAssessExam.state === RisrAssessExamStates.PUSHED">Start the exam</span>
        <span *ngIf="risrAssessExam.state === RisrAssessExamStates.STARTED">Resume the exam</span>
      </button>
    </div>
  </div>

  <div *ngIf="risrAssessExam.state === RisrAssessExamStates.RESULTS_READY">
    <rsr-alert varuiant="accent">
      <p *ngIf="!risrAssessExam.resultEventUrl" i18n>
        The exam results are being finalised. Please wait…
      </p>
      <p i18n *ngIf="risrAssessExam.resultEventUrl">
        The exam has been finalised and your results are available.
      </p>
    </rsr-alert>

    <button *ngIf="risrAssessExam.resultEventUrl" mat-flat-button color="primary" (click)="openResultEventUrl(risrAssessExam.resultEventUrl)">View Results</button>
  </div>
</div>
